// removed by extract-text-webpack-plugin
module.exports = {"Banner":"_10EoU6nDS2JfqKD22Dh0u2","JibberImageLogoTextBody":"_22hqTL_kdwo6opcPDy5xFk","NavBar":"_2sxSda5BiSyCrXIVlZ7564","ConversationTitle":"_3G7N3U3Ov0ZTTewd42TvmI","ConversationWith":"_1EK1EgrWEzTlZr5HojgZOZ","ConversationName":"_3zdtU3fW5P2dAiHKSNJgW9","MainPanelHeaderMenu":"_1bFaSYjqNor786ORsRfad3","PreviewImage":"_3a06mjkBqXFk_hng86IMAy","NumberUnread":"_2tXOcVYYbYZk0vhhJQfEan","messageBox":"_2_AYuE0MwiyEMGYJSEG3C0","searchButton":"oFuNWM4qpSNdRWaiwOsK8","activate":"o1ic7ApCgA0YBc2qpt1Sk"};


//////////////////
// WEBPACK FOOTER
// ./src/layout/Dashboard/Header/style.css
// module id = 1862
// module chunks = 0